import { comp } from "../func/comp";
import { __sortOpts } from "../internal/sort-opts";
import { $iter } from "../iterator";
import { map } from "./map";
import { partition } from "./partition";
export function movingMedian(...args) {
    const iter = $iter(movingMedian, args);
    if (iter) {
        return iter;
    }
    const { key, compare } = __sortOpts(args[1]);
    const n = args[0];
    const m = n >> 1;
    return comp(partition(n, 1, true), map((window) => window.slice().sort((a, b) => compare(key(a), key(b)))[m]));
}
